import styled from 'styled-components'

import { ReactComponent as CrossIcon } from '../../../../styles/assets/checkoutModal/cross.svg'
import { palette } from '../../../../styles/variables'

const ErrorWrapper = styled.div(({ type }) => ({
  border: `1px solid ${palette[type]}`,
  backgroundColor: `${palette[type]}${type === 'danger' ? '20' : '40'}`,
  borderRadius: '2px',
  padding: '16px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '24px',
  '>span': {
    fontSize: '14px',
    lineHeight: '20px',
    flexGrow: 1,
  },
}))

export default ({ type = 'danger', children, onClose }) => {
  return (
    <ErrorWrapper type={type}>
      <span>{children}</span>
      <CrossIcon
        style={{ cursor: 'pointer', flexShrink: 0 }}
        onClick={onClose}
      />
    </ErrorWrapper>
  )
}
